export const AUTH_STORAGE_KEY: string = 'auth';
